import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import React from "react";
import { Helmet } from "react-helmet";

import PageWrap from "../../components/PageWrap";

const Tarrifs = () => (
  <div>
    <Helmet>
      <title>lisanslama.org - Tarifeler</title>
      <meta
        name="description"
        content="Online lisanslama tarifeler sayfası, lisanslama.org tarifeler sayfası, lisanslama.org tarifeler hakkında bilgi"
      />
    </Helmet>
    <PageWrap title="Tarifeler" homeText="Anasayfa" pageName="Tarifeler" />

    <MDBContainer className="my-5">
      <MDBRow>
        <MDBCol md="12" className="d-flex flex-column">
          <a href="/documents/MUYAP_2026_Yili_Tarifesi_EK-A.xlsx" download target="_self">
            <span>2026 YILI MÜ-YAP EK A TARİFESİNİ İNDİRMEK İÇİN TIKLAYINIZ</span>
          </a>
          <a href="/documents/MUYAP_2025_Yili_Tarifesi_EK-A.xlsx" download target="_self">
            <span>2025 YILI MÜ-YAP EK A TARİFESİNİ İNDİRMEK İÇİN TIKLAYINIZ</span>
          </a>
          <a href="/documents/MUYAP_2024_Yili_Tarifesi_EK-A.xlsx" download target="_self">
            <span>2024 YILI MÜ-YAP EK A TARİFESİNİ İNDİRMEK İÇİN TIKLAYINIZ</span>
          </a>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  </div>
);

export default Tarrifs;
